import React, { useCallback } from "react";
import { NoteBackgroundColorOptions } from "@features/context-menus/components/NoteBackgroundColorOptions";
import { AnyObject } from "@thenounproject/lingo-core";

type ItemType = "note" | "portalNote";

type BaseItem = {
  id: string;
  data?: {
    backgroundColor?: string;
  };
};

type NoteUpdates = {
  updatedItems: {
    uuid: string;
    data: {
      background_color: string;
    };
  }[];
};

type PortalNoteUpdates = {
  portalItemId: string;
  updates: {
    data: {
      background_color: string;
    };
  };
};

type SaveFn = (args: AnyObject) => void;

type ToolbarColorMenuProps<Item extends BaseItem> = {
  item: Item;
  saveFn: SaveFn;
  type: ItemType;
};

export default function ToolbarColorMenu<Item extends BaseItem>({
  item,
  saveFn,
  type,
}: ToolbarColorMenuProps<Item>) {
  const selectedColor =
    item?.data?.backgroundColor !== "default" ? item.data?.backgroundColor : "#ff0000";

  const editNoteBackground = useCallback(
    (background: string) => {
      let updates: NoteUpdates | PortalNoteUpdates;
      if (type === "note") {
        updates = { updatedItems: [{ uuid: item.id, data: { background_color: background } }] };
      } else {
        updates = { portalItemId: item.id, updates: { data: { background_color: background } } };
      }
      void saveFn(updates);
    },
    [item.id, saveFn, type]
  );

  return (
    <NoteBackgroundColorOptions
      selectedColor={selectedColor}
      editItemBackground={editNoteBackground}
      nested={false}
    />
  );
}
